import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import WarningIcon from "@mui/icons-material/Warning";
import {
  Box,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  useTheme,
} from "@mui/material";
import { ChallengeEventType } from "../../directus/collections";
import { MatchEnigmaDetailView } from "../MatchEnigmaDetailView";
import { MatchRowData } from "./ChallengeMatchOverviewTable.types";

interface ChallengeMatchTableRowProps {
  row: MatchRowData;
  columns: ChallengeEventType[];
  highlightColumns?: ChallengeEventType[];
  onToggleExpand: (matchId: string, targetId: string) => void;
}

export function ChallengeMatchTableRow({
  row,
  columns,
  highlightColumns,
  onToggleExpand,
}: ChallengeMatchTableRowProps) {
  const renderEventCell = (row: MatchRowData, column: ChallengeEventType) => {
    const value = row.events[column] || 0;
    const isHighlighted = highlightColumns?.includes(column);
    const theme = useTheme();

    return (
      <TableCell
        key={column}
        sx={{
          backgroundColor: isHighlighted
            ? theme.palette.primary.light
            : "inherit",
          fontWeight: isHighlighted ? "bold" : "normal",
          color: isHighlighted ? theme.palette.primary.contrastText : "inherit",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {value}
          {false && (
            <Tooltip title="Possibili inconsistenze nei dati">
              <WarningIcon color="warning" fontSize="small" />
            </Tooltip>
          )}
        </Box>
      </TableCell>
    );
  };

  return (
    <>
      {/* Main row */}
      <TableRow
        hover
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
          backgroundColor: row.expanded ? "action.selected" : "inherit",
        }}
      >
        <TableCell>
          <IconButton
            size="small"
            onClick={() => onToggleExpand(row.matchId, row.challengeId)}
          >
            {row.expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{row.teamName}</TableCell>
        <TableCell>{row.challengeName}</TableCell>
        <TableCell>
          {row.startDate && new Date(row.startDate).toLocaleDateString()}
        </TableCell>
        {columns.map((column) => renderEventCell(row, column))}
        <TableCell>
          <Tooltip title="Apri dettagli in nuova finestra">
            <IconButton
              size="small"
              href={`${row.gameLink}&spectator=true`}
              target="_blank"
            >
              <LaunchOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
      {/* Expanded row */}
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={columns.length + 6}
        >
          <Collapse in={row.expanded} timeout="auto" unmountOnExit>
            <MatchEnigmaDetailView
              matchId={row.matchId}
              enigmaId={row.challengeId}
              columns={columns}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
